<template>
  <div class="page">
    <div class="container">
      <parcels-list></parcels-list>

      <router-link :to="{ name: 'mapa' }">
        <button class="button is-primary is-fullwidth">
          {{ $t("page.content.parcels_map") }}
        </button>
      </router-link>
    </div>
  </div>
</template>

<script>
import ParcelsList from "@/components/ParcelsList"

export default {
  name: "Parcels",
  components: { ParcelsList },
}
</script>
